import { useMemo } from 'react';
import { createTheme, Theme } from '@mui/material/styles';
import Logo from '../../public/Logo.png';
import '../index.scss';

// const theme: any = useTheme();
// const isMobile = useMediaQuery(theme.breakpoints.down('md'));

const theme1: any = {
  palette: {
    mode: 'light',
    primary: { main: '#984216' },
    secondary: { main: '#4A3A2E' }, //TODO: temp color
    background: {
      default: 'rgb(248,236,221)',
      // paper: 'rgba(225, 187, 136, 0.3)',
      paper: '#ffffff',
    },
    navbar: { primary: '#000000' },
    text: { primary: '#000000', secondary: '#984216', GrayText: '#707070' },
    customColor1: { main: 'rgb(255, 243, 223)' },
    primaryFade: { main: 'rgba(152, 66, 22, 0.1)' },
    grayBorder: { main: '#D9D9D9' },
  },
  typography: {
    fontFamily: `'Montserrat', 'Proxima Nova Condensed', sans-serif !important;`,
  },
  customHeading: {
    fontFamily: `'copperplate_gothic', 'Montserrat', 'Proxima Nova Condensed', sans-serif !important;`,
  },
  maxWidth: {
    width: '1536px',
  },
  logo: Logo,
  socialMediaLinks: {
    instagram: 'https://instagram.com/snapcityinpune?igshid=YmMyMTA2M2Y=',
    facebook: 'https://www.facebook.com/Snapcity-IN-PUNE-104475251191834',
    whatsapp: '9130901234',
    youtubeChannel: '',
    email: 'snapcityinpune@gmail.com',
  },
  // breakpoints: {
  //   values: {
  //     xs: 0,
  //     sm: 600,
  //     md: 900,
  //     lg: 1200,
  //     xl: 1536,
  //   },
  // },
};
// const theme2: any = {
//   palette: {
//     mode: 'light',
//     // primary: { main: '#984216' },
//     // secondary: { main: '#4A3A2E' },
//     primary: { main: '#262339' },
//     secondary: { main: '#3A2E' }, //TODO: temp color
//     background: {
//       default: 'rgba(225, 187, 136, 0.3)',
//       paper: 'rgba(225, 187, 136, 0.3)',
//     },
//     text: { primary: '#000000', secondary: '#ffffff', GrayText: '#707070' },
//     customColor1: { main: 'rgb(255, 243, 223)' },
//     customColor2: { main: 'rgb(255, 243, 223)' },
//   },
//   typography: {
//     fontFamily: `'copperplate Gothic Bold', 'Montserrat','Proxima Nova Condensed', sans-serif !important;`,
//   },
//   customHeading: {
//     fontFamily: `'copperplate_gothic', 'Montserrat', 'Proxima Nova Condensed', sans-serif`,
//   },
//   maxWidth: {
//     width: '100%',
//   },
//   logo: Logo,
//   socialMediaLinks: {
//     instagram: 'https://instagram.com/snapcityinpune?igshid=YmMyMTA2M2Y=',
//     facebook: 'https://www.facebook.com/Snapcity-IN-PUNE-104475251191834',
//     whatsapp: 'https://wa.me/message/XCXQSXICIZ2QG1',
//   },
// };

const theme2: any = {
  palette: {
    mode: 'light',
    primary: { main: '#984216' },
    secondary: { main: '#4A3A2E' }, //TODO: temp color
    background: {
      default: 'rgb(248,236,221)',
      // paper: 'rgba(225, 187, 136, 0.3)',
      paper: '#ffffff',
    },
    navbar: { primary: '#ffffff' },
    text: { primary: '#000000', secondary: '#984216', GrayText: '#707070' },
    customColor1: { main: 'rgb(255, 243, 223)' },
    primaryFade: { main: 'rgba(152, 66, 22, 0.1)' },
    grayBorder: { main: '#D9D9D9' },
  },
  typography: {
    fontFamily: `'Montserrat', 'Proxima Nova Condensed', sans-serif !important;`,
  },
  customHeading: {
    fontFamily: `'copperplate_gothic', 'Montserrat', 'Proxima Nova Condensed', sans-serif !important;`,
  },
  maxWidth: {
    width: '100%',
  },
  logo: Logo,
  socialMediaLinks: {
    instagram: 'https://instagram.com/snapcityinpune?igshid=YmMyMTA2M2Y=',
    facebook: 'https://www.facebook.com/Snapcity-IN-PUNE-104475251191834',
    whatsapp: '9130901234',
    youtubeChannel: '',
    email: 'snapcityinpune@gmail.com',
  },
  // breakpoints: {
  //   values: {
  //     xs: 0,
  //     sm: 600,
  //     md: 900,
  //     lg: 1200,
  //     xl: 1536,
  //   },
  // },
};
const myTheme = import.meta.env.VITE_THEME;
const isFullScreen = myTheme == 'Theme2';
interface UseThemeModeReturn {
  theme: Theme;
}
const useThemeMode = (): UseThemeModeReturn => {
  const theme = useMemo(() => {
    switch (myTheme) {
      case 'Theme1':
        return createTheme(theme1);
      case 'Theme2':
      default:
        return createTheme(theme2);
    }
  }, [myTheme]);

  return { theme };
};

export default useThemeMode;
export { myTheme, isFullScreen };
